import { ModalV2 } from "react-migration/components/ModalV2/ModalV2";
import { UserColorMenu } from "../../UserMenu/UserColorMenu";

export const UserColorModal = ({ setUserColorModal }: { setUserColorModal: (v: boolean) => void }) => {
  return (
    <ModalV2.Root defaultOpen={true} onOpenChange={setUserColorModal}>
      <ModalV2.Body
        title="User Color"
        className="z-99999!"
        contentClassName="w-[500px]!"
        descriptionClassName="overflow-visible!"
      >
        <UserColorMenu />
      </ModalV2.Body>
    </ModalV2.Root>
  );
};
